export const disabledRoutes = new Map([
  [1, ['グループ', 'センサー', 'ユーザ']], // 配送員
  [2, []], // 管理者
  [3, []],
  [4, []] // システム管理者(admin, zerospec)
])
